import { 
  LOAD_ENUM_DATA_IN_PROGRESS,
  LOAD_ENUM_DATA_SUCCESS,
  LOAD_ENUM_DATA_FAILURE,
  OPEN_ENUMS_DIALOG,
  CLOSE_ENUMS_DIALOG,
  LOAD_ENUM_SINGLE_DATA,
  ENUM_OPERATION_COMPLETED
} from "./actions";

const initialState = { isLoading: false, enumArrayData: [], enumSingleData:[] };

export const enumData = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    
    case LOAD_ENUM_DATA_SUCCESS: {
      const { data } = payload;
      return {
        ...state,
        isLoading: false,
        enumArrayData: data,
      };
    }
    case LOAD_ENUM_DATA_IN_PROGRESS:
      return {
        ...state,
        isLoading: true,
      };
    case LOAD_ENUM_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
      case ENUM_OPERATION_COMPLETED:
        return {
            ...state,
            isLoading: false,
        }; 
      case OPEN_ENUMS_DIALOG:
        return {
          ...state,
          isEnumsDialogOpen: true,
        }; 

      case CLOSE_ENUMS_DIALOG:
        return {
          ...state,
          isEnumsDialogOpen: false,
        }; 
      case LOAD_ENUM_SINGLE_DATA:{
        const { data } = payload;
        return {
            ...state,
            isLoading: false,
            enumSingleData : data,
        }
      }
      default:
        return state;
  }
};
